import * as React from 'react';
import { useEffect, useState } from 'react';
import { Survey, LanguageCode, LanguageCodes } from '../amorg-common';
import { useParams } from 'react-router-dom';
import { LoadStatus, StartAnswer } from '../features/surveyAnswers/StartAnswer';
import { getSurveyAsAnonymous } from '../api/surveySubmissionClientApi';
import { stxt } from '../SurveyTxt';
import { FluidLeftFixedRightLayout } from '../designSystem/layouts/FluidLeftFixedRightLayout';
import { LanguageSelector } from '../designSystem/compositeComponents/LanguageSelector';
import { getBrowserLanguage } from '../utils/getBrowserLanguage';
import { PageHeader } from '../designSystem/PageHeader';
import { PublicPageWrapper } from './_pageWrappers/PublicPageWrapper';


export function StartSurveyAnswerPage(): JSX.Element 
{
    return <StartSurveyAnswerPageContent />
}


type PageState = {
    loadStatus:LoadStatus,
    survey:Survey,
    email:string,
};

function StartSurveyAnswerPageContent(): JSX.Element {
    const params = useParams<{ siteId:string, surveyId:string }>();

    const [state, setState] = useState<PageState>({
        loadStatus: 'loading',
        survey:null,
        email:''
    });
    
    const [selectedLanguage,setSelectedLanguage] = useState<LanguageCode>(getBrowserLanguage());

    useEffect(() => {
        const getData = async () => {
            const survey = await getSurveyAsAnonymous(params.siteId, params.surveyId);
            setState({
                ...state,
                survey,
                loadStatus: survey ? 'done' : 'error'
            });
        };
        getData();
    }, []);

    const availableLanguages = LanguageCodes.map(lc => lc);

    const txt = stxt(selectedLanguage);

    return (
        <PublicPageWrapper>
            <FluidLeftFixedRightLayout
                noDivider
                headerContainer={
                    <PageHeader headerText={txt.startAnswer_header} headerStyle='primary-black'
                        buttons={
                            <LanguageSelector
                                availableLanguages={availableLanguages}
                                selectedLanguage={selectedLanguage}
                                onSelectedLanguageChange={(languageCode) => setSelectedLanguage(languageCode)} />
                            }/>
                }
                leftContainer={
                    <StartAnswer
                        {...state}
                        siteId={params.siteId}
                        selectedLanguage={selectedLanguage}
                        onEmailChange={(val)=> setState({...state, email:val}) }
                    />
                }
                rightContainer={
                <></>
                }
            />
        </PublicPageWrapper>
    );
}